(function () {
  'use strict';

  var promptCopy = {
    'understand-mid': {
      question: 'Understand M.I.D.™',
      answer: 'M.I.D.™ is the material platform used in O-Mira One. It is a passive, battery-free approach designed for measured bioenergetic modulation in connected life.'
    },
    'lab-results': {
      question: 'What do the lab results mean?',
      answer: 'O-Mira refers to early biophotonic laboratory observations on blood and plasma samples. These observations are non-clinical and should be understood as measured laboratory signals, not diagnosis, treatment, prevention, or guaranteed outcomes.'
    },
    'how-to-use': {
      question: 'How do I use O-Mira One?',
      answer: 'O-Mira One is designed as a passive product: no app, no battery, and no daily setup routine. Follow the product instructions for placement and keep using your connected device normally.'
    },
    compatibility: {
      question: 'Is O-Mira One compatible with my phone?',
      answer: 'O-Mira One is positioned for everyday connected life with smartphone use. For exact fit and setup guidance, review the product page or contact O-Mira support before purchase.'
    },
    'modulation-boundary': {
      question: 'What does modulation, not blocking, mean?',
      answer: 'O-Mira One is not presented as a signal blocker. The focus is M.I.D.™ material modulation while connected devices continue to work normally.'
    },
    buy: {
      question: 'Where can I buy O-Mira One?',
      answer: 'You can review O-Mira One details and purchase through the official product page.',
      linkText: 'Open O-Mira One',
      linkUrl: '/products/o-mira-one-emf'
    }
  };

  var fallbackAnswer = 'I can help with approved O-Mira One topics: M.I.D.™ material, measured bioenergetic modulation for connected life, early biophotonic laboratory observations, passive use, compatibility, and purchase next steps. O-Mira One is not a medical device.';
  var usageLimit = 20;
  var usageWindowMs = 24 * 60 * 60 * 1000;
  var usageStorageKey = 'omiraAssistantUsage:v1';
  var usageLimitMessage = 'I’ve reached today’s guidance limit for this assistant. For deeper support, please contact the O-Mira team.';

  function initAssistant(root) {
    var launcher = root.querySelector('[data-omira-assistant-open]');
    var panel = root.querySelector('[data-omira-assistant-panel]');
    var closeButton = root.querySelector('[data-omira-assistant-close]');
    var log = root.querySelector('[data-omira-assistant-log]');
    var form = root.querySelector('[data-omira-assistant-form]');
    var input = root.querySelector('[data-omira-assistant-input]');
    var promptButtons = root.querySelectorAll('[data-omira-assistant-prompt]');
    var endpoint = (root.getAttribute('data-endpoint') || '').trim();
    var limitMessageShown = false;

    if (!launcher || !panel || !closeButton || !log || !form || !input) {
      return;
    }

    function openPanel() {
      panel.hidden = false;
      panel.setAttribute('aria-hidden', 'false');
      launcher.setAttribute('aria-expanded', 'true');
      window.setTimeout(function () {
        input.focus();
      }, 0);
    }

    function closePanel() {
      panel.hidden = true;
      panel.setAttribute('aria-hidden', 'true');
      launcher.setAttribute('aria-expanded', 'false');
      launcher.focus();
    }

    function addMessage(text, type, link) {
      var message = document.createElement('div');
      var paragraph = document.createElement('p');

      message.className = 'omira-ai-assistant__message omira-ai-assistant__message--' + type;
      paragraph.textContent = text;
      message.appendChild(paragraph);

      if (link && link.url && link.text) {
        paragraph.appendChild(document.createTextNode(' '));
        var anchor = document.createElement('a');
        anchor.href = link.url;
        anchor.textContent = link.text;
        paragraph.appendChild(anchor);
      }

      log.appendChild(message);
      log.scrollTop = log.scrollHeight;
    }

    function getDemoResponse(message, promptKey) {
      var normalized = message.toLowerCase();
      var prompt = promptCopy[promptKey];

      if (!prompt) {
        if (normalized.indexOf('buy') !== -1 || normalized.indexOf('purchase') !== -1) {
          prompt = promptCopy.buy;
        } else if (normalized.indexOf('lab') !== -1 || normalized.indexOf('result') !== -1 || normalized.indexOf('biophotonic') !== -1) {
          prompt = promptCopy['lab-results'];
        } else if (normalized.indexOf('emf') !== -1 || normalized.indexOf('protect') !== -1 || normalized.indexOf('block') !== -1 || normalized.indexOf('modulation') !== -1) {
          prompt = promptCopy['modulation-boundary'];
        } else if (normalized.indexOf('compat') !== -1 || normalized.indexOf('phone') !== -1) {
          prompt = promptCopy.compatibility;
        } else if (normalized.indexOf('use') !== -1 || normalized.indexOf('app') !== -1 || normalized.indexOf('battery') !== -1) {
          prompt = promptCopy['how-to-use'];
        } else if (normalized.indexOf('mid') !== -1 || normalized.indexOf('m.i.d') !== -1 || normalized.indexOf('material') !== -1) {
          prompt = promptCopy['understand-mid'];
        }
      }

      if (!prompt) {
        return { answer: fallbackAnswer };
      }

      return {
        answer: prompt.answer,
        linkText: prompt.linkText,
        linkUrl: prompt.linkUrl
      };
    }

    function setLoading(isLoading) {
      input.disabled = isLoading;
      form.querySelector('button[type="submit"]').disabled = isLoading;
    }

    function getUsageState() {
      var now = Date.now();
      var fallback = {
        count: 0,
        resetAt: now + usageWindowMs
      };

      try {
        var stored = window.localStorage.getItem(usageStorageKey);
        var parsed = stored ? JSON.parse(stored) : fallback;

        if (!parsed || typeof parsed.count !== 'number' || typeof parsed.resetAt !== 'number' || parsed.resetAt <= now) {
          window.localStorage.setItem(usageStorageKey, JSON.stringify(fallback));
          return fallback;
        }

        return parsed;
      } catch (error) {
        return fallback;
      }
    }

    function saveUsageState(state) {
      try {
        window.localStorage.setItem(usageStorageKey, JSON.stringify(state));
      } catch (error) {
        // If storage is unavailable, keep the assistant usable and rely on backend rate limits.
      }
    }

    function hasReachedUsageLimit() {
      return getUsageState().count >= usageLimit;
    }

    function recordUsage() {
      var state = getUsageState();
      state.count += 1;
      saveUsageState(state);
      return state;
    }

    function showUsageLimit() {
      if (!limitMessageShown) {
        addMessage(usageLimitMessage, 'assistant');
        limitMessageShown = true;
      }

      input.disabled = true;
      form.querySelector('button[type="submit"]').disabled = true;
    }

    function respond(message, promptKey) {
      if (!endpoint) {
        var demo = getDemoResponse(message, promptKey);
        addMessage(demo.answer, 'assistant', {
          text: demo.linkText,
          url: demo.linkUrl
        });
        return;
      }

      setLoading(true);
      window.fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          message: message,
          page: window.location.pathname
        })
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Assistant endpoint failed');
          }
          return response.json();
        })
        .then(function (data) {
          addMessage(data && data.answer ? data.answer : fallbackAnswer, 'assistant');
        })
        .catch(function () {
          addMessage(fallbackAnswer, 'assistant');
        })
        .finally(function () {
          setLoading(false);
          input.focus();
        });
    }

    function submitMessage(message, promptKey) {
      var trimmed = message.trim();

      if (!trimmed) {
        return;
      }

      if (hasReachedUsageLimit()) {
        showUsageLimit();
        return;
      }

      addMessage(trimmed, 'user');
      input.value = '';
      recordUsage();
      respond(trimmed, promptKey);
    }

    launcher.addEventListener('click', function () {
      if (panel.hidden) {
        openPanel();
      } else {
        closePanel();
      }
    });

    closeButton.addEventListener('click', closePanel);

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      submitMessage(input.value, null);
    });

    Array.prototype.forEach.call(promptButtons, function (button) {
      button.addEventListener('click', function () {
        var promptKey = button.getAttribute('data-omira-assistant-prompt');
        var prompt = promptCopy[promptKey];

        if (!prompt) {
          return;
        }

        submitMessage(prompt.question, promptKey);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !panel.hidden) {
        closePanel();
      }
    });

    document.addEventListener('click', function (event) {
      if (!panel.hidden && !root.contains(event.target)) {
        closePanel();
      }
    });
  }

  function initAll() {
    var assistants = document.querySelectorAll('[data-omira-ai-assistant]');
    Array.prototype.forEach.call(assistants, initAssistant);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
